export default [
  {
    path: '/error-404',
    name: 'error-404',
    component: () => import('@/views/error/Error404.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      action: 'read',
    },
  },
  {
    path: '/error-403',
    name: 'misc-not-authorized',
    component: () => import('@/views/error/NotAuthorized.vue'),
    meta: {
      resource: 'Auth',
    },
  },
  {
    path: '/error-401',
    name: 'access-denied',
    component: () => import('@/views/error/AccessDenied.vue'),
    meta: {
      resource: 'Auth',
    },
  },
]
